import angular from "angular";
angular.module("angular.emlpayments", []);